(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faq-group"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.faq-group__toggle').forEach(function (button) {
      var group = button.closest('.faq-group');
      var content = group.querySelector('.faq-group__content');
      var inner = group.querySelector('.faq-group__inner');

      // Set initial height for groups based on their state
      if (group.classList.contains('is-open')) {
        content.style.height = 'auto';
      } else {
        content.style.height = '0px';
      }

      button.addEventListener('click', function () {
        var isOpen = group.classList.contains('is-open');

        if (isOpen) {
          // Collapse: set explicit height first, then animate to 0
          content.style.height = inner.offsetHeight + 'px';
          // Force reflow
          content.offsetHeight;
          content.style.height = '0px';
          group.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'false');
        } else {
          // Expand: animate from 0 to content height
          group.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
          content.style.height = inner.offsetHeight + 'px';

          // After transition, set auto so content can resize naturally
          content.addEventListener('transitionend', function handler() {
            content.removeEventListener('transitionend', handler);
            if (group.classList.contains('is-open')) {
              content.style.height = 'auto';
            }
          });
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.faq-item .faq-question').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.faq-item');
        var section = item.closest('.faq-section');
        var answer = item.querySelector('.faq-answer');
        var inner = answer.querySelector('.faq-answer__inner');
        var isOpen = item.classList.contains('is-open');

        // Close all other items in this section
        if (section) {
          section.querySelectorAll('.faq-item.is-open').forEach(function (openItem) {
            if (openItem !== item) {
              var openAnswer = openItem.querySelector('.faq-answer');
              var openInner = openAnswer.querySelector('.faq-answer__inner');
              openAnswer.style.height = openInner.offsetHeight + 'px';
              openAnswer.offsetHeight;
              openAnswer.style.height = '0px';
              openItem.classList.remove('is-open');
              openItem.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
              openAnswer.setAttribute('aria-hidden', 'true');
            }
          });
        }

        if (isOpen) {
          // Collapse
          answer.style.height = inner.offsetHeight + 'px';
          answer.offsetHeight;
          answer.style.height = '0px';
          item.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'false');
          answer.setAttribute('aria-hidden', 'true');
        } else {
          // Expand
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
          answer.setAttribute('aria-hidden', 'false');
          answer.style.height = inner.offsetHeight + 'px';

          answer.addEventListener('transitionend', function handler() {
            answer.removeEventListener('transitionend', handler);
            if (item.classList.contains('is-open')) {
              answer.style.height = 'auto';
            }
          });
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
